<script setup lang="ts">
import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KCheckboxField from '@/components/fields/KCheckboxField.vue';
import KMultipleSelectField from '@/components/fields/KMultipleSelectField.vue';
import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';
import { ticketsStatusItems } from '@/constants/fieldItems';

export interface InitialData {
  status?: string[] | null;
  search?: string | null;
  isRfc?: boolean;
  isUnread?: boolean;
}

export interface ValidData {
  status?: string[] | null;
  search?: string | null;
  isRfc?: boolean;
  isUnread?: boolean;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.ticketsDashboardSearchForm"
    data-testid="ticketsDashboardSearchForm"
    @submit.prevent="handleSubmit"
  >
    <KMultipleSelectField
      v-model="formData.status"
      size="lg"
      label="Ticket status"
      :disabled="props.loading"
      :class="[$style.field, $style.selectField]"
      :items="ticketsStatusItems"
      :plusCount="3"
      @keydown.enter="handleSubmit"
    />
    <KTextField
      v-model="formData.search"
      size="lg"
      label="Search"
      :disabled="props.loading"
      :class="$style.field"
      messages="Job ID, Subject"
    />
    <KBtn
      type="submit"
      size="lg"
      prepend-icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    >
      Search
    </KBtn>
    <div :class="$style.checkboxGroup">
      <KCheckboxField
        v-model="formData.isRfc"
        label="Requested for change only"
        :class="$style.checkboxField"
        :disabled="props.loading"
      />
      <KCheckboxField
        v-model="formData.isUnread"
        label="Unread only"
        :class="$style.checkboxField"
        :disabled="props.loading"
      />
    </div>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.ticketsDashboardSearchForm {
}
  .field {
    width: 17.5rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .selectField {
  }
  .checkboxGroup {
    margin-bottom: 0.5rem;
    display: flex;
    flex-wrap: wrap;
  }
    .checkboxField {
      margin-right: 1.5rem; // same as .v-selection-control--inline.v-radio
    }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
